import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import { Layout } from "./components/Layout";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};
import Index from "./pages/Index";
const ServicePage = lazy(() => import("./pages/ServicePage"));
import LocationPage from "./pages/LocationPage";
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const BathroomCostPage = lazy(() => import("./pages/BathroomCostPage"));
const KitchenCostPage = lazy(() => import("./pages/KitchenCostPage"));
const TimelinePage = lazy(() => import("./pages/TimelinePage"));
const PermitsPage = lazy(() => import("./pages/PermitsPage"));
const FAQPage = lazy(() => import("./pages/FAQPage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogPostFullHomeRemodel = lazy(
  () => import("./pages/BlogPostFullHomeRemodel"),
);
const BlogPostEstimateTool = lazy(() => import("./pages/BlogPostEstimateTool"));
const BlogPostKitchenBathTiming = lazy(
  () => import("./pages/BlogPostKitchenBathTiming"),
);
const BlogPostFallRoofing = lazy(() => import("./pages/BlogPostFallRoofing"));
const BlogPostFindContractor = lazy(
  () => import("./pages/BlogPostFindContractor"),
);
const TwoDayRefreshPage = lazy(() => import("./pages/TwoDayRefreshPage"));
const QuotePage = lazy(() => import("./pages/QuotePage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Index />} />
              <Route path="/services/:serviceId" element={<ServicePage />} />
              <Route
                path="/service-areas/:locationId"
                element={<LocationPage />}
              />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route
                path="/bathroom-remodel-cost-raleigh"
                element={<BathroomCostPage />}
              />
              <Route
                path="/kitchen-remodel-cost-nc"
                element={<KitchenCostPage />}
              />
              <Route path="/remodel-timeline" element={<TimelinePage />} />
              <Route path="/nc-remodel-permits" element={<PermitsPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route
                path="/blog/full-home-remodel-cost-raleigh-nc"
                element={<BlogPostFullHomeRemodel />}
              />
              <Route
                path="/blog/how-long-vistas-interactive-quote-form-works"
                element={<BlogPostEstimateTool />}
              />
              <Route
                path="/blog/why-late-summer-golden-window-kitchen-bath-remodels-nc"
                element={<BlogPostKitchenBathTiming />}
              />
              <Route
                path="/blog/why-fall-deadline-roofing-exterior-work-triangle"
                element={<BlogPostFallRoofing />}
              />
              <Route
                path="/blog/how-to-find-reliable-contractor-raleigh"
                element={<BlogPostFindContractor />}
              />
              <Route path="/two-day-refresh" element={<TwoDayRefreshPage />} />
              <Route path="/quote" element={<QuotePage />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
